import {MuiPickersOverrides} from '@material-ui/pickers/typings/overrides';
import {Theme} from '@material-ui/core/styles/createMuiTheme';

export const createMuiPickersCalendarHeaderOverrides = ({
    palette,
    spacing,
    typography
}: Theme): MuiPickersOverrides['MuiPickersCalendarHeader'] => ({
    switchHeader: {
        minWidth: 330,
        marginTop: spacing(2),
        padding: spacing(0, 2),
        marginBottom: undefined
    },
    iconButton: {
        backgroundColor: undefined
    },
    transitionContainer: {
        marginTop: undefined,
        height: spacing(8),

        "&>[class*='MuiTypography-root']": {
            ...typography.button,
            lineHeight: 1.25,
            fontSize: '12px',
            top: spacing(2.7),
            '&::after': {
                content: '"\\25BC"',
                display: 'inline-block',
                transform: 'scale(1.5, 0.8)',
                cursor: 'pointer',
                width: spacing(4),
                margin: spacing(0, 1, 0, 2)
            }
        }
    },
    daysHeader: {
        minWidth: 330,
        maxHeight: undefined,
        justifyContent: 'space-between'
    },
    dayLabel: {
        width: spacing(12),
        lineHeight: 1.25,
        padding: spacing(2.5, 0),
        textAlign: 'center',
        // @ts-ignore
        color: palette.dividerStrong,
        margin: undefined
    }
});
